import { Check } from 'lucide-react';
import { billSelectedToggleClass, billUnselectedToggleClass } from '@/components/bills/billPaymentUtils';
import { cn } from '@/utils/cn';

interface BillMeterTypeToggleProps {
  value: 'prepaid' | 'postpaid';
  onChange: (value: 'prepaid' | 'postpaid') => void;
}

export function BillMeterTypeToggle({ value, onChange }: BillMeterTypeToggleProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {(['prepaid', 'postpaid'] as const).map((type) => {
        const isSelected = value === type;
        return (
          <button
            key={type}
            type="button"
            onClick={() => onChange(type)}
            className={cn(
              'relative rounded-xl border-2 px-4 py-3.5 text-center text-sm font-medium capitalize transition-all',
              isSelected ? billSelectedToggleClass : billUnselectedToggleClass,
            )}
          >
            {type}
            {isSelected && (
              <span className="absolute bottom-2 right-2 flex h-5 w-5 items-center justify-center rounded-full bg-secondary-500 text-white">
                <Check className="h-3 w-3" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
